import type { FaireProductEntity } from "../../entity_types/product";

export const p_ntdbye9zhr: FaireProductEntity = {
  token: "p_ntdbye9zhr",
  type: "product",
  name: "Flower Power Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8e349c69ab0c9898b55e626b05b51eb8b04ced15d28d240070652773eef54931.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c02f38a9452aa2a8c791c541959a76b6338c152f6a1fc5d99831a9b12aeb6697.webp",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:20.260Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
